import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Accordion } from 'semantic-ui-react';

import OriginalPurchaseTransaction from './OriginalPurchaseTransaction';
import PaymentAndFees from './PaymentAndFees';
import TitleStatus from './TitleStatus';
import ReturnInformation from './ReturnInformation';
import DisbursementInformation from './DisbursementInformation';
import SystemInformation from './SystemInformation';
import ResaleInformation from './ResaleInformation';

class VehicleDetails extends Component {
  render() {
    const {
      vehicleRecord,
      isAuctionEdgeLocation,
      activeIndex,
      handleClick,
      paymentStatus,
      formatField,
      formatDate,
      formatDateTime,
      formatCurrency,
      vehicleNetColourComparison,
    } = this.props;
    return (
      <Accordion fluid styled exclusive>
        <OriginalPurchaseTransaction
          formatField={formatField}
          formatDate={formatDate}
          isAuctionEdgeLocation={isAuctionEdgeLocation}
          activeIndex={activeIndex}
          handleClick={handleClick}
        />
        <PaymentAndFees
          vehicleRecord={vehicleRecord}
          formatField={formatField}
          formatDate={formatDate}
          formatDateTime={formatDateTime}
          formatCurrency={formatCurrency}
          activeIndex={activeIndex}
          handleClick={handleClick}
          paymentStatus={paymentStatus}
          vehicleNetColourComparison={vehicleNetColourComparison}
        />
        <TitleStatus
          formatField={formatField}
          formatDate={formatDate}
          activeIndex={activeIndex}
          handleClick={handleClick}
        />
        <div style={{ backgroundColor: 'black' }}>
          <br />
          <br />
          <br />
        </div>
        <ReturnInformation
          vehicleRecord={vehicleRecord}
          formatField={formatField}
          formatDate={formatDate}
          activeIndex={activeIndex}
          handleClick={handleClick}
        />
        <ResaleInformation
          vehicleRecord={vehicleRecord}
          formatField={formatField}
          formatDate={formatDate}
          activeIndex={activeIndex}
          handleClick={handleClick}
        />
        <DisbursementInformation
          formatField={formatField}
          formatDate={formatDate}
          formatCurrency={formatCurrency}
          activeIndex={activeIndex}
          handleClick={handleClick}
        />
        <SystemInformation
          formatField={formatField}
          activeIndex={activeIndex}
          handleClick={handleClick}
        />
      </Accordion>
    );
  }
}

VehicleDetails.propTypes = {
  vehicleRecord: PropTypes.object.isRequired,
  isAuctionEdgeLocation: PropTypes.func.isRequired,
  activeIndex: PropTypes.array.isRequired,
  handleClick: PropTypes.func.isRequired,
  paymentStatus: PropTypes.func.isRequired,
  formatField: PropTypes.func.isRequired,
  formatDate: PropTypes.func.isRequired,
  formatDateTime: PropTypes.func.isRequired,
  formatCurrency: PropTypes.func.isRequired,
  vehicleNetColourComparison: PropTypes.func.isRequired,
};

export default VehicleDetails;
